module.exports = __webpack_public_path__ + "img/Baumwipfelquatsch.55fd3aab.jpg";